<mat-card appearance="outlined" class="offset-xl-4 col-xl-4 offset-md-3 col-md-6 col-sm-12">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>account_box</mat-icon> Hort360 Manager - Login
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="text-left">
      <strong><i>Note: You must be a facilitator of Growcom in order to use this system.</i></strong>
      <br/><br/>
      <form (ngSubmit)="loginUser()">
        <mat-form-field [floatLabel]="'auto'" appearance="fill" class="w-100">
          <mat-label>Email or username</mat-label>
          <mat-icon matPrefix class="mr-2">email</mat-icon>
          <input matInput autocomplete="on" id="email" name="email" type="email" [(ngModel)]="emailAddress" />
        </mat-form-field>
        <br/>
        <mat-form-field [floatLabel]="'auto'" appearance="fill" class="w-100">
          <mat-label>Password</mat-label>
          <mat-icon matPrefix class="mr-2">password</mat-icon>
          <input matInput autocomplete="on" id="password" name="password" type="password" [(ngModel)]="password" />
        </mat-form-field>
      </form>
      <div class="text-right">
        <button mat-raised-button color="primary" (click)="loginUser()">Login</button>
      </div>
    </mat-card-content>
</mat-card>
